import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class SubscriptionActivityButton extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-subscription-activity-button', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let button = $(event.currentTarget),
        route  = button.data('route'),
        label  = button.prev('span');

    if (typeof route === 'undefined') {
      return false;
    }

    event.preventDefault();

    button.addClass('is-loading');

    return this.App.API.post(route, {}).catch((error) => {

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    }).then((response) => {

      if (response.data) {
        button.text(this.App.Language.get('users.profile.subscription.activity.' + response.data.activity.action));
        label.text(this.App.Language.get('users.profile.subscription.activity.' + response.data.activity.state));

        return true;
      }

      return this.App.UI.Dialog.alert(
        this.App.Language.get('errors.internal_error')
      );

    }).finally(() => {
      button.removeClass('is-loading');
    });

  }

}